import cn from 'classnames';
import { type FC } from 'react';

import type { Study } from '@/model/Study.model';
import type { ClassificationType } from '@/model/Treatment.model';

import type { OverviewTreatmentRow } from '../../OverviewAccordion.model';
import OverviewTreatmentsTable from './OverviewTreatmentsTable';
import { useOverviewTreatmentInfoModal } from './useOverviewTreatmentInfoModal';

interface EditableOverviewTreatmentsTableProps {
  rows: Array<OverviewTreatmentRow>;
  study: Study;
  type: ClassificationType;
}

/**
 * Treatments and diseases tables whose labels open the groups-table treatment info modal.
 */
const EditableOverviewTreatmentsTable: FC<EditableOverviewTreatmentsTableProps> = ({ rows, study, type }) => {
  const { loadingTreatment, openTreatmentInfo } = useOverviewTreatmentInfoModal(study);

  return (
    <div className={cn({ ui__disabled: loadingTreatment })}>
      <OverviewTreatmentsTable
        rows={rows}
        type={type}
        studyId={String(study.id)}
        onLabelClick={(row) => {
          void openTreatmentInfo(row.api_id, type);
        }}
      />
    </div>
  );
};

export default EditableOverviewTreatmentsTable;
